import { useState } from "react";
import { faqData } from "@/mocks/landingData";
import { useScrollReveal } from "@/hooks/useScrollReveal";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const { ref, visible } = useScrollReveal({ threshold: 0.1 });

  return (
    <section id="faq" ref={ref} className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-8 lg:px-12">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-accent-500 text-base font-medium tracking-[0.2em] uppercase mb-3">
            FAQ
          </p>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 leading-tight mb-4">
            Common Questions
          </h2>
          <p className="text-foreground-700 text-xl max-w-2xl mx-auto">
            Everything you need to know before taking the next step.
          </p>
        </div>

        <div
          className={`space-y-3 transition-all duration-600 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"
          }`}
          style={{ transitionTimingFunction: "cubic-bezier(0.22, 0.61, 0.36, 1)" }}
        >
          {faqData.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-lg border border-background-200/70 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between p-5 md:p-6 text-left btn-hover-lift"
              >
                <span className="font-heading text-lg md:text-xl font-medium text-foreground-950 pr-4">
                  {faq.question}
                </span>
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 shrink-0">
                  <i
                    className={`ri-arrow-down-s-line text-xl transition-transform duration-300 ${
                      openIndex === idx ? "rotate-180" : ""
                    }`}
                  />
                </div>
              </button>
              <div
                className={`grid transition-all duration-400 ease-in-out ${
                  openIndex === idx ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                }`}
              >
                <div className="overflow-hidden">
                  <div className="px-5 md:px-6 pb-5 md:pb-6 text-foreground-700 text-lg md:text-xl leading-relaxed">
                    {faq.answer}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}